/* eslint-disable promise/always-return */
import { request } from "common/components/request";
import { toast } from "extensions/toast";

export const GET_FILTERS = function() {
    return (dispatch, getState) => {
        dispatch({
            type: "filters/FILTERS_FETCH_START"
        });
        
        return request("/merchant/:merchant_ref/user/filters").then((data) => {
            dispatch({
                type: "filters/FILTERS_FETCH_SUCCESS",
                data
            });
            return data;
        }, (error) => Promise.reject(error));
    };
};

export const SAVE_NEW_FILTER = function(newFilter) {
    return (dispatch, getState) => {
        dispatch({
            type: "filters/FILTERS_SAVE_START"
        });
        
        return request("/merchant/:merchant_ref/user/filters", {
            method: "POST",
            data: newFilter
        }).then((data) => {
            toast.success("Your filter was successfully saved.");
            dispatch({
                type: "filters/FILTERS_SAVE_SUCCESS",
                data
            });
        }, (error) => Promise.reject(error));
    };
};

export const UPDATE_FILTER = function(updateFilter) {
    return (dispatch, getState) => {
        dispatch({
            type: "filters/FILTERS_UPDATE_START"
        });
        
        return request(`/merchant/:merchant_ref/user/filters/${updateFilter._id}`, {
            method: "PUT",
            data: updateFilter
        }).then((data) => {
            toast.success("Your filter was successfully updated.");
            dispatch({
                type: "filters/FILTERS_UPDATE_SUCCESS",
                data: updateFilter
            });
        }, (error) => Promise.reject(error));
    };
};

export const DELETE_SAVED_FILTER = function(id) {
    return (dispatch, getState) => request(`/merchant/:merchant_ref/user/filters/${id}`, {
        method: "DELETE"
    }).then((data) => {
        toast.success("Your filter was removed.");
        dispatch({
            type: "filters/FILTERS_DELETE_SUCCESS",
            data: id
        });
    }, (error) => {
        dispatch({
            type: "filters/FILTERS_DELETE_ERROR",
            error
        });
        return Promise.reject(error);
    });
};
